// extracted by mini-css-extract-plugin
export default {"brandPromo":"pH-z","carousel":"qH-z"};